import { Component, input, ChangeDetectionStrategy } from '@angular/core';

import { Lagerplatz, LagerplatzInhalt } from '@softapps/lager/core';
import { ResolvableModal} from '@softline/ui-core';
import { StockAmountComponent } from '../../components/stock-amount/stock-amount.component';

@Component({
  selector: 'soft-lagerplatz-auswahl',
  imports: [StockAmountComponent],
  templateUrl: './lagerplatz-auswahl.dialog.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './lagerplatz-auswahl.dialog.css' })
export class LagerplatzAuswahlDialog extends ResolvableModal<Lagerplatz> {
  lagerplatzInhalte = input.required<LagerplatzInhalt[]>();
}
